<template>
    <div class="body scroll_bar">
        <div v-if="initData.noticeMode" ref="notice" class="notice">
            <span class="icon"></span>
            <div >{{noticeText}}</div>
        </div>
        <Loadmore
            style="min-height:100%"
            :auto-file="false"
            :top-status.sync="loadStatus"
            :top-method="loadHistory"
            ref="loadmore"
        >

            <div
                slot="top"
                class="mint-loadmore-top"
            >
                <span v-show="!loadStatus">{{ $t('getHistory') }}</span>
                <span v-show="loadStatus === 'loading'">{{ $t('loading') }}</span>
<!--                <span v-show="loadStatus === 'end'">{{ $t('noHistory') }}</span>-->
            </div>

            <div style="padding-top: 23px">
                <div
                    class="message_item"
                    v-for="item in chatList"
                    :key="item.date"
                    v-if="!item.recallFlag"
                    :class="item.senderType === 2||item.senderType === 3?'left':item.senderType === 1?'right':'center'"
                >
                    <!--            机器人3 或者  人工客服2-->
                    <div
                        v-if="item.senderType === 2||item.senderType === 3"
                        class="left_message"
                    >
                        <div class="face" v-if="initData.avatar">
                            <img :src="item.faceUrl">
                        </div>
                        <div class="message">
                            <div class="send_name">{{ item.senderName }} {{ formDate(item.msgTime,'MM-dd hh:mm:ss')}}</div>
                            <!--  各种消息类型 -->
                            <div
                                v-if="(item.msgType===1||!item.msgType)&&item.docPattern!==1"
                                class="text_message"
                            >
                                <div v-html="item.msgContent"></div>
                                <div v-html="item.answer"></div>
                                <div
                                    class="guide" :style="{color:initData.kitBgcolor}"

                                    @click="guideSend(guide)"
                                    v-for="(guide,$index) in item.suggestList"
                                    v-html="$index+1+'.'+guide.question"
                                ></div>
                            </div>
                            <!--  多轮问题展示 -->
                            <div
                                v-if="(item.msgType===1||item.msgType===3||!item.msgType)&&item.docPattern===1"
                                class="text_message"
                            >
                                <div
                                    v-html="item.answer"
                                    v-if="item.docNode.nodeType !== 3"
                                ></div>
                                <iframe
                                    :src="item.answer"
                                    frameborder="0"
                                    v-if="item.docNode.nodeType === 3"
                                ></iframe>
                                <div
                                    class="guide series"
                                    @click="seriesProblem(guide)"
                                    v-if="item.docNode.nodeType === 1"
                                    v-for="(guide,$index) in item.docNode.itemList"
                                    v-html="guide.itemContent"
                                ></div>
                            </div>
                            <div
                                v-if="item.msgType===2"
                                class="image_message"
                            >
                                <img
                                    :src="item.msgContent"
                                    :alt="item.fileName"
                                    @click="showLargeImage(item)"
                                >
                            </div>
                            <!--              机器人的富文本-->
                            <div
                                v-if="item.msgType===3 && item.senderType === 3&&item.docPattern!==1"
                                class="text_message"
                            >
                                <div v-html="item.msgContent"></div>
                                <div
                                    class="guide" :style="{color:initData.kitBgcolor}"
                                    v-for="(guide,$index) in JSON.parse(item.robotSuggest)"
                                    @click="guideSend(guide)"
                                    v-html="$index+1+'.'+guide.question"
                                ></div>
                            </div>
                            <!--              人工富文本-->
                            <div
                                v-if="item.msgType===3 && item.senderType === 2&&item.docPattern!==1"
                                class="card_message"
                            >
                                <img :src="JSON.parse(item.msgContent).picture">
                                <div class="info">
                                    <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                                    <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                                    <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                                </div>
                            </div>

                            <div
                                v-if="item.msgType===4"
                                class=" file_message"
                                @click="chooseFile(item)"
                            >
                                <div class="file_icon">
                                    <svg
                                        t="1617682401274"
                                        class="icon"
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        p-id="2051"
                                        width="32"
                                        height="32"
                                    >
                                        <path
                                            d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                            fill="#bfbfbf"
                                            p-id="2052"
                                        ></path>
                                    </svg>
                                </div>
                                <div class="file_name">
                                    <div>{{ item.fileName }}</div>
                                    <!--                  <div class="file_size">-->
                                    <!--                    <span v-if="item.size">{{ item.size }}k</span>-->
                                    <!--                    <a :href="item.msgContent">下载</a>-->
                                    <!--                  </div>-->
                                </div>

                            </div>
                            <div
                                v-if="item.msgType===7"
                                class="goods_message"
                            >
                                <div
                                    class="goods_info"
                                    @click="goCardDetail(item)"
                                >
                                    <div class="goods_image">
                                        <img
                                            :src="JSON.parse(item.msgContent).imgUrl"
                                            alt=""
                                        >
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="goods_label">{{ JSON.parse(item.msgContent).label }}</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="item.msgType===8"
                                class="order_message"
                            >
                                <div class="goods_info">
                                    <div class="goods_image">
                                        <img
                                            :src="JSON.parse(item.msgContent).imgUrl"
                                            alt=""
                                        >
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="card_status">
                      <span class="order_status">
                        {{ JSON.parse(item.msgContent).orderStatus }}
                      </span>
                                            <span class="time">
                        {{ JSON.parse(item.msgContent).orderTime }}
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="false">
                                <span>{{ $t('thump') }}</span>
                                <span>{{ $t('top') }}</span>
                            </div>
                        </div>
                    </div>
                    <!--            用户-->
                    <div
                        v-if="item.senderType === 1"
                        class="right_message"
                    >
                        <div class="message">
                            <div class="send_name"> {{ formDate(item.msgTime,'MM-dd hh:mm:ss') }} </div>
<!--{{ item.senderName }}-->
                            <!--  各种消息类型              -->
                            <div
                                v-if="item.msgType===1"
                                class="text_message"
                                :style="{backgroundColor:initData.kitBgcolor,color:initData.kitTxcolor}"
                                v-html="item.msgContent"
                            ></div>
                            <div
                                v-if="item.msgType===2"
                                class=" image_message"
                            >
                                <img
                                    :src="item.msgContent"
                                    :alt="item.name"
                                    @click="showLargeImage(item)"
                                >
                            </div>
                            <div
                                v-if="item.msgType===3"
                                class="card_message"
                            >
                                <img :src="JSON.parse(item.msgContent).picture">
                                <div class="info">
                                    <div class="title">{{ JSON.parse(item.msgContent).title }}</div>
                                    <div class="desc">{{ JSON.parse(item.msgContent).desc }}</div>
                                    <div class="price">{{ JSON.parse(item.msgContent).price }}</div>
                                </div>
                            </div>
                            <div v-if="item.msgType===9" class="card_message card_order"  :style="{backgroundColor:initData.kitBgcolor,color:initData.kitTxcolor}">
                                <div class="info">
                                    <div :style="{color:initData.kitTxcolor}" class="desc" v-for="(key,value) in JSON.parse(item.msgContent)" v-if="key&&value">
                                        {{ value }}:{{key}}
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="item.msgType===4"
                                class=" file_message"
                                @click="chooseFile(item)"
                            >
                                <div class="file_icon">
                                    <svg
                                        t="1617682401274"
                                        class="icon"
                                        viewBox="0 0 1024 1024"
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        p-id="2051"
                                        width="32"
                                        height="32"
                                    >
                                        <path
                                            d="M597.333333 85.333333H256c-46.933333 0-84.906667 38.4-84.906667 85.333334L170.666667 853.333333c0 46.933333 37.973333 85.333333 84.906666 85.333334H768c46.933333 0 85.333333-38.4 85.333333-85.333334V341.333333l-256-256z m85.333334 682.666667H341.333333v-85.333333h341.333334v85.333333z m0-170.666667H341.333333v-85.333333h341.333334v85.333333z m-128-213.333333V149.333333L789.333333 384H554.666667z"
                                            fill="#bfbfbf"
                                            p-id="2052"
                                        ></path>
                                    </svg>
                                </div>
                                <div class="file_name">
                                    <div>{{ item.fileName }}</div>
                                    <!--                  <div class="file_size">-->
                                    <!--                    <span v-if="item.size">{{ item.size }}k</span>-->
                                    <!--                    <a :href="item.msgContent">下载</a>-->
                                    <!--                  </div>-->
                                </div>
                            </div>
                            <div
                                v-if="item.msgType===5"
                                class=" audio_message"
                            >
                                <audio
                                    :src="item.msgContent"
                                    controls
                                ></audio>
                            </div>
                            <div
                                v-if="item.msgType===6"
                                class=" video_message"
                            >
                                <video
                                    :src="item.msgContent"
                                    controls
                                ></video>
                            </div>
                            <div
                                v-if="item.msgType===7"
                                class="goods_message"
                            >
                                <div
                                    class="goods_info"
                                    @click="goCardDetail(item)"
                                >
                                    <div class="goods_image">
                                        <img
                                            :src="JSON.parse(item.msgContent).imgUrl"
                                            alt=""
                                        >
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="goods_label">{{ JSON.parse(item.msgContent).label }}</div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="item.msgType===8"
                                class="order_message"
                            >
                                <div
                                    class="goods_info"
                                    @click="goCardDetail(item)"
                                >
                                    <div class="goods_image">
                                        <img
                                            :src="JSON.parse(item.msgContent).imgUrl"
                                            alt=""
                                        >
                                    </div>
                                    <div class="goods_detail">
                                        <div class="goods_title">{{ JSON.parse(item.msgContent).title }}</div>
                                        <div class="goods_desc">{{ JSON.parse(item.msgContent).describe }}</div>
                                        <div class="card_status">
                      <span class="order_status">
                        {{ JSON.parse(item.msgContent).orderStatus }}
                      </span>
                                            <span class="time">
                        {{ JSON.parse(item.msgContent).orderTime }}
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <i
                                v-if="item.status === 'loading'"
                                class="el-icon-loading status"
                            ></i>
                            <i
                                v-if="item.status === 'failed'"
                                class="el-icon-warning status"
                            ></i>
                        </div>
                        <div v-if="initData.avatar && false" class="face">
                            <img :src="item.faceUrl">
                        </div>
                    </div>
                    <!--            系统消息-->
                    <div
                        v-if="item.senderType === 4"
                        class="system_message"
                    >
                        <span :class="item.type === 1?'normal':'bg'" v-html="item.msgContent "></span>
                    </div>
                </div>
                <span
                    v-scroll-bottom="scrollBottom"
                    class="scroll_auto scroll-bottom"
                ></span>
            </div>
        </Loadmore>
        <div
            class="shade"
            v-if="btRecoding"
            catchtouchmove="ture"
        >
            <div
                class="blackBoxSpeak"
                v-if="blackBoxSpeak"
            >
                <div>
                    <img src="../../../static/image/lz.png"/>
                </div>
                <p class="blackBoxSpeakConent">手指上划，取消录制</p>
            </div>
            <div
                class="blackBoxPause"
                v-else
            >
                <img src="../../../static/image/qxlz.png"/>
                <p
                    class="blackBoxSpeakConent"
                    style="color:red"
                >松开手指，取消录制</p>
            </div>
        </div>

        <Popup
            style="width:100%;background: none;background: transparent;"
            v-model="showImage"
        >
            <img
                @click="showImage = !showImage"
                :src="largeImageUrl"
                class="large_image"
                alt=""
            >
        </Popup>
    </div>
</template>

<script>
    import language from "../../store/index";
    import {Loadmore} from "mint-ui";
    import chatApi from "../methods";
    import store from "../../store/index";
    import {Popup} from "mint-ui";
    import bus from "@/utils/bus";

    export default {
        name: "Body",
        data() {
            return {
                timeOutId: null,
                showImage: false,
                largeImageUrl: "",
                noticeText: "",
                btRecoding: false,
                blackBoxSpeak: false,
            };
        },
        components: {
            Loadmore,
            Popup,
        },
        mounted() {
            bus.$on("closeScreen", (res) => {
                this.btRecoding = res.btRecoding;
                this.blackBoxSpeak = res.blackBoxSpeak;
            });
            setTimeout(()=>{
                document.querySelector(".message_item").onclick = function (e) {
                    const link = e.target.getAttribute("data-link");
                    if (link) {
                        window.open(link);
                    }
                };
            },1000)

        },
        methods: {
            formDate(value, fmt) {
                if(!value){
                    return ''
                }
                fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
                if(value&&value<10000000000){
                    value=value*1000;
                }

                let getDate = new Date(value*1);
                let o = {
                    'M+': getDate.getMonth() + 1,
                    'd+': getDate.getDate(),
                    'h+': getDate.getHours(),
                    'm+': getDate.getMinutes(),
                    's+': getDate.getSeconds(),
                    'q+': Math.floor((getDate.getMonth() + 3) / 3),
                    'S': getDate.getMilliseconds()
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
                }
                for (let k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                    }
                }
                return fmt;
            },
            loadHistory() {
                if (this.loadStatus !== "end") {
                    this.$refs.loadmore.onTopLoaded();
                    store.dispatch("setLoadingStatus", "loadStart");
                    chatApi.getHistoryList({pageSize: 20, maxTime: 0});
                }
            },
            chooseFile(file) {
                console.log(file);
                window.open(file.msgContent, "_blank");
            },
            // 点击引导问题
            guideSend(guide) {
                const obj = {
                    docId: guide.docId,
                    click: 1,
                    msgContent: guide.question,
                    senderType: 1, // 发送人 1用户，2客服，3机器人
                    date: new Date().getTime(),
                    msgType: 1, // 消息类型 1文本
                    status: "loading", // 消息状态 成功后隐藏否则一直loading
                    id: "message" + new Date().getTime(),
                };
                // 更新聊天消息
                this.$store.dispatch("setChatList", obj);
                chatApi.sendMessage(obj);
            },
            // 点击多轮问题
            seriesProblem(guide) {
                const obj = {
                    docId: guide.docId,
                    itemId: guide.itemId,
                    click: 1,
                    msgContent: guide.itemContent,
                    senderType: 1, // 发送人 1用户，2客服，3机器人
                    date: new Date().getTime(),
                    msgType: 1, // 消息类型 1文本
                    status: "loading", // 消息状态 成功后隐藏否则一直loading
                    id: "message" + new Date().getTime(),
                };
                // 更新聊天消息
                this.$store.dispatch("setChatList", obj);
                chatApi.sendMessage(obj);
            },
            // 点击技能组
            selectGroup(group) {
                this.$store.dispatch("setShowChannelGroup", false);
                chatApi.transfer(group);
            },
            //跳转到商品详情
            goCardDetail(card) {
                try {
                    let obj = JSON.parse(card.msgContent);
                    window.open(obj.fromUrl, "_blank");
                } catch (e) {
                }
            },
            // 图片点击放大
            showLargeImage(img) {
                if (img.msgContent) {
                    this.showImage = true;
                    this.largeImageUrl = img.msgContent;
                }
            },
        },
        computed: {
            chatList() {
                return this.$store.state.chatList;
            },
            scrollBottom() {
                return this.$store.state.scrollBottom;
            },
            loadStatus() {
                return this.$store.state.loadStatus;
            },
            agentTyping() {
                if (this.$store.state.agentTyping) {
                    document.title = "客服正在输入...";
                }
                if (this.timeOutId) {
                    clearTimeout(this.timeOutId);
                }
                this.timeOutId = setTimeout(() => {
                    // document.title = '用户咨询';
                    document.title = this.$store.state.initData.titleDesc || this.$t('userQuestion');
                }, 1200);
            },
            initData() {
                console.log(this.$store.state.initData.avatar)
                return this.$store.state.initData;
            },
        },
        watch: {
            chatList() {
                return this.$store.state.chatList;
            },
            scrollBottom() {
                setTimeout(() => {
                    document.getElementsByClassName("scroll-bottom")[0].scrollIntoView();
                }, 100);
            },
            loadStatus() {
                return this.$store.state.loadStatus;
            },
            agentTyping() {
                return this.$store.state.agentTyping;
            },
            initData() {
                console.log(this.$store.state.initData.avatar)

                if (this.$store.state.initData.noticeMode && this.$store.state.initData.noticeMsg) {
                    const div = document.createElement('div')
                    div.innerHTML = this.$store.state.initData.noticeMsg
                    this.noticeText = div.textContent || div.innerText;
                    setTimeout(() => {
                        let time = parseInt(this.noticeText.length / 9).toFixed(0) || 15
                        if (time < 10) time = 15
                        if (!!this.$refs) {
                            this.$refs.notice.style.animationDuration = ` ${time}s `;
                        }
                    }, 20)
                }
                return this.$store.state.initData;
            },
        },
        directives: {
            // 发送消息后滚动到底部
            "scroll-bottom"(el) {
                setTimeout(() => {
                    // el.scrollIntoView()
                }, 100);
            },
        },
    };
</script>
<style scoped>
    .body {
        background: #ffffff;
    }

    .notice {
        padding: 3px 0;
        background: #fdf6d7;
        text-align: left;
        color: #563c3c;
        font-size: 13px;
        line-height: 20px;
        height: 23px;
        position: fixed;
        width: 100%;
        /*top:46px;*/
        z-index: 3;
    }

    .notice .icon {
        position: absolute;
        z-index: 9;
        display: inline-block;
        width: 20px;
        background-color: #fdf6d7;
        height: 20px;
        vertical-align: middle;
        background-size: 100% 100%;
        background-image: url("../../../static/image/notice.png");
    }

    .notice > div {
        display: inline-block;
        vertical-align: middle;
        animation: 14s move linear infinite normal;
        white-space: nowrap;
    }

    @keyframes move {
        0% {
            transform: translateX(320px);
            -webkit-transform: translateX(320px);
        }

        100% {
            transform: translateX(-100%);
            -webkit-transform: translateX(-100%);
        }
    }

    .notice p {
        margin: 2px;
    }

    .scroll_auto {
        height: 2px;
        display: block;
    }

    .message {
        position: relative;
        max-width: 100%;
        word-break: break-word;
    }

    .message .status {
        position: absolute;
        font-size: 16px;
        bottom: 0;
        color: #999;
    }

    .message .el-icon-warning {
        color: red;
    }

    .image_message,
    .audio_message,
    .video_message {
        max-width: 100%;
    }

    .audio_message audio,
    .video_message video {
        max-width: 100%;
    }

    .image_message img {
        width: auto;
        max-width: 100px;
    }

    .guide {
        line-height: 30px;
    }

    .right_message {
        max-width: 79%;
        overflow: hidden;
    }

    .file_message {
        display: inline-block;
        padding: 8px;
        background: #f4f4f4;
        border-radius: 5px;
    }

    .file_message div {
        display: inline-block;
        vertical-align: middle;
    }

    .file_name {
        max-width: 300px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .large_image {
        width: auto;
        max-width: 90%;
    }

    .card_message {
        border: 1px solid #e6e6e6;
        padding: 15px;
        cursor: pointer;
        border-radius: 0 10px 10px 10px;
    }
    .card_order{
        text-align: left;
        padding: 10px;
        width: 180px;
        background: #7467F0;
    }
    .card_order .info .desc{
        height: 20px;
        line-height: 20px;
    }
    .card_order.card_message .info {
        height: auto;
        width: 100%;
    }

    .right_message .card_message {
        border-radius: 10px 0 10px 10px;
    }

    .card_message img {
        width: 65px;
        height: 65px;
        vertical-align: middle;
    }

    .card_message .info {
        display: inline-block;
        vertical-align: middle;
        width: 140px;
        margin: 0 10px;
        height: 65px;
    }

    .info .title,
    .price {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
    }

    .info .title {
        font-size: 14px;
        font-weight: 600;
    }

    .info .desc {
        font-size: 12px;
        color: #666;
        text-align: left;
        height: 34px;

        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }

    .info .price {
        color: #7467f0;
        font-size: 12px;
    }

    .series {
        display: inline-block;
        padding: 0px 15px;
        border: 1px solid #e5e5e5;
        border-radius: 3px;
        margin: 5px;
        overflow: hidden;
        max-width: 180px;
        height: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #7467f0;
        background-color: white;
    }

    .series:active {
        background: #f3f3f3;
        color: #596788;
    }

    div.goods_message,
    div.order_message {
        border: 1px solid #f0f0f0;
        padding: 7px;
        cursor: pointer;
        border-radius: 0 10px 10px;
    }

    .goods_info {
        background-color: #f9fafe;
        display: flex;
    }

    .goods_info > div,
    .order_message > div {
        vertical-align: middle;
    }

    .goods_image img {
        width: 80px;
        height: 80px;
        display: inline-block;
        overflow: hidden;
        border-radius: 2px;
    }

    .goods_detail {
        width: 203px;
        height: 80px;
        display: inline-block;
    }

    .goods_title {
        font-size: 14px;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 24px;
        text-align: left;
        white-space: nowrap;
        color: #333;
        padding: 1px 7px;
    }

    .goods_desc {
        text-align: left;
        line-height: 26px;
        font-size: 14px;
        padding: 0 7px;
        color: #666;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .goods_label {
        text-align: left;
        line-height: 30px;
        font-size: 16px;
        padding: 0 7px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #ff5756;
    }

    .card_status {
        font-size: 0;
    }

    .card_status span {
        vertical-align: middle;
        overflow: hidden;
        height: 18px;
    }

    .card_status .order_status {
        width: 70px;
        display: inline-block;
        text-align: left;
        color: #ebab28;
        font-size: 14px;
        padding-left: 8px;
    }

    .card_status .time {
        font-size: 12px;
        width: 116px;
        display: inline-block;
        text-align: right;
        color: #999;
        height: 12px;
        vertical-align: bottom;
    }

    .shade {
        z-index: 998;
        position: absolute;
        top: 30%;
        left: 25%;
        background-color: rgba(129, 125, 125, 0.8);
        width: 50vw;
        height: 200px;
        border-radius: 16px;
    }

    .shade img {
        margin-top: 20px;
        width: 148 rpx;
        height: 246 rpx;
    }

    .shade .blackBoxSpeak,
    .shade .blackBoxPause {
        width: 343 rpx;
        height: 343 rpx;
        border-radius: 24 rpx;
        margin: auto;
        padding: 32 rpx;
        position: relative;
        text-align: center;
        top: 188 rpx;
    }

    .shade .blackBoxSpeakConent {
        width: 100%;
        padding-top: 30px;
        color: #fff;
        text-align: center;
        margin: auto;
        border-radius: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/h5/body.vue